export default __webpack_public_path__ + "static/media/39.cec6e574.jpg";